
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iZbq8", function(module, exports) {

$parcel$export(module.exports, "playersList", () => $dd26c85d58b7d2de$export$524b16c2fb9dd359);
$parcel$export(module.exports, "playersListItems", () => $dd26c85d58b7d2de$export$4b7050694877ba52);
$parcel$export(module.exports, "removeDiv", () => $dd26c85d58b7d2de$export$d932814d2123f199);
$parcel$export(module.exports, "listItemTemplate", () => $dd26c85d58b7d2de$export$f8f517b1dee64471);
$parcel$export(module.exports, "startNextButton", () => $dd26c85d58b7d2de$export$5996a89a1f477391);
$parcel$export(module.exports, "accumulateCheckbox", () => $dd26c85d58b7d2de$export$7971d9e093d1c8c1);
$parcel$export(module.exports, "resetButton", () => $dd26c85d58b7d2de$export$69181d24bfc61261);
$parcel$export(module.exports, "turnTimeInput", () => $dd26c85d58b7d2de$export$56cb494ef4afabb9);
$parcel$export(module.exports, "pauseButton", () => $dd26c85d58b7d2de$export$e2a09eedfba3d2a);
$parcel$export(module.exports, "deleteAllButton", () => $dd26c85d58b7d2de$export$b8b30aec8fe088a7);
$parcel$export(module.exports, "updatePlayersList", () => $dd26c85d58b7d2de$export$c668bd4713a22d46);
const $dd26c85d58b7d2de$export$524b16c2fb9dd359 = document.getElementById("players-list");
let $dd26c85d58b7d2de$export$4b7050694877ba52 = $dd26c85d58b7d2de$export$524b16c2fb9dd359.querySelectorAll("li");
const $dd26c85d58b7d2de$export$d932814d2123f199 = document.getElementById("remove-div");
const $dd26c85d58b7d2de$export$f8f517b1dee64471 = document.getElementById("list-item-template");
const $dd26c85d58b7d2de$export$5996a89a1f477391 = document.getElementById("start-next-button");
const $dd26c85d58b7d2de$export$7971d9e093d1c8c1 = document.getElementById("accumulate-checkbox");
const $dd26c85d58b7d2de$export$69181d24bfc61261 = document.getElementById("reset-button");
const $dd26c85d58b7d2de$export$56cb494ef4afabb9 = document.getElementById("turn-time-input");
const $dd26c85d58b7d2de$export$e2a09eedfba3d2a = document.getElementById("pause-button");
const $dd26c85d58b7d2de$export$b8b30aec8fe088a7 = document.getElementById("delete-all-button");
function $dd26c85d58b7d2de$export$c668bd4713a22d46() {
    $dd26c85d58b7d2de$export$4b7050694877ba52 = $dd26c85d58b7d2de$export$524b16c2fb9dd359.querySelectorAll("li");
}

});

/**
 * Dragging actions on the list.
 */ 
var $iZbq8 = parcelRequire("iZbq8");
let $cf32ff4c045e705a$var$draggingElement;
//When the dragging action starts, add dragging class to the dragging item.
(0, $iZbq8.playersList).addEventListener("dragstart", (e)=>{
    $cf32ff4c045e705a$var$draggingElement = e.target;
    $cf32ff4c045e705a$var$draggingElement.classList.add("dragging");
    (0, $iZbq8.removeDiv).classList.add("visible");
});
//When the item is dragged over the list
(0, $iZbq8.playersList).addEventListener("dragover", (e)=>{
    e.preventDefault(); // This is necessary to allow drop action.
    const afterElement = e.target.nextElementSibling;
    let underElement = null;
    // From the whole list, get the element under the dragging element.
    for (const element of (0, $iZbq8.playersListItems))if ($cf32ff4c045e705a$var$isTheElementContainingTheCoordinates(element, e.clientX, e.clientY)) {
        underElement = element;
        break;
    }
    if (underElement != null) $cf32ff4c045e705a$var$changeElementsOrder(underElement, $cf32ff4c045e705a$var$draggingElement);
    if ($cf32ff4c045e705a$var$isTheElementContainingTheCoordinates((0, $iZbq8.removeDiv), e.clientX, e.clientY)) (0, $iZbq8.removeDiv).classList.add("focused");
    else (0, $iZbq8.removeDiv).classList.remove("focused");
});
// Clean up styles on drop
(0, $iZbq8.playersList).addEventListener('dragend', (e)=>{
    e.target.classList.remove('dragging');
    if ($cf32ff4c045e705a$var$isTheElementContainingTheCoordinates((0, $iZbq8.removeDiv), e.clientX, e.clientY)) e.target.remove();
    (0, $iZbq8.removeDiv).classList.remove("visible");
});
/**
 * Checks if a specific set of coordinates falls within the bounding box of the element.
 * @param {HTMLElement} element
 * @param {number} x
 * @param {number} y
 * @returns {boolean} True if the coordinates are within the elements bounds
 * */ function $cf32ff4c045e705a$var$isTheElementContainingTheCoordinates(element, x, y) {
    const rect = element.getBoundingClientRect();
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}
/**
 * Change the elements order.
 * @param {HTMLElement} underElement
 * @param {HTMLElement} draggingElement
 * */ function $cf32ff4c045e705a$var$changeElementsOrder(underElement, draggingElement) {
    if (underElement.nextElementSibling) {
        if (draggingElement.compareDocumentPosition(underElement) & Node.DOCUMENT_POSITION_FOLLOWING) (0, $iZbq8.playersList).insertBefore(underElement, draggingElement);
        else (0, $iZbq8.playersList).insertBefore(draggingElement, underElement);
    } else (0, $iZbq8.playersList).appendChild(draggingElement);
    (0, $iZbq8.updatePlayersList)();
}


//# sourceMappingURL=rummiclock.59c65f2f.js.map
